module.exports = __webpack_public_path__ + "img/deepwater2.5c84913b.png";